<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            lượt thi pháp luật</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Người thi:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Người thi..." v-model="search.cNguoiThi" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <!-- <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm lượt thi</span>
            </el-button> -->
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaLuotThi" label="Mã" align="center" width="80"></el-table-column>
            <el-table-column prop="cNguoiThi" show-overflow-tooltip class="text-nowrap" label="Người thi">
            </el-table-column>
            <el-table-column prop="nKetQua" show-overflow-tooltip class="text-nowrap" label="Kết quả" width="80" align="center">
              <template #default="scope">
                <span v-if="scope.row.listPCauHoiLuotThiPhapLuat">{{ scope.row.nKetQua }} / {{
                  scope.row.listPCauHoiLuotThiPhapLuat.length }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nTinhDiem" show-overflow-tooltip class="text-nowrap" label="Tính điểm" width="90" align="center">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <!-- <el-button plain type="primary" :disabled="scope.row.nTrangThai == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button> -->
                <el-button plain type="info" data-bs-toggle="modal" data-bs-target="#modal_news"
                  @click="handleOpenView(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-eye"></i></span>
                </el-button>

                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0 || !handleCheckPerms('p:lawExams:delete')"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Xem lượt thi" : "Cập nhật lượt thi" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Người thi" prop="cNguoiThi">
                <el-input :disabled="!operation" v-model="formData.cNguoiThi" />
              </el-form-item>
              <el-form-item label="Thời gian làm bài" prop="nThoiGianLamBai">
                <!-- <el-input :disabled="!operation" v-model="formData.nThoiGianLamBai" /> -->
                {{ handleProcessTime(formData.nThoiGianLamBai) }}
              </el-form-item>
              <el-form-item label="Ngày thi" prop="dNgayTao">
                <el-date-picker type="date" :disabled="!operation" v-model="formData.dNgayTao" />
              </el-form-item>
              <el-form-item label="Bài thi">
                <el-table :data="formData.listPCauHoiLuotThiPhapLuat" border stripe max-height="350" fit>
                  <el-table-column prop="cCauHoi" label="Nội dung câu hỏi" header-align="center">
                    <template #default="scope">
                      {{ scope.row.pCauHoiPhapLuat.cCauHoi }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="nCauTraLoi" label="Câu trả lời" header-align="center">
                    <template #default="scope">
                      {{ handleGetAnswer(scope.row.pCauHoiPhapLuat.listPDapAnPhapLuat, scope.row.nCauTraLoi) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Đáp án" header-align="center">
                    <template #default="scope">
                      {{ handleGetAnswer(scope.row.pCauHoiPhapLuat.listPDapAnPhapLuat,
                        scope.row.pCauHoiPhapLuat.nDapAnDung) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" width="70">
                    <template #default="scope">
                      <el-tag type="success" v-if="scope.row.nCauTraLoi == scope.row.pCauHoiPhapLuat.nDapAnDung"
                        size="small">Đúng</el-tag>
                      <el-tag type="danger" v-else size="small">Sai</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <!-- <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button> -->
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { LawExams } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";

import { CookieComponent } from "@/assets/ts/components";

export default {
  name: 'LawExams',

  data() {
    return {
      
      perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
      test: "",
      search: {
        cNguoiThi: "",
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cNguoiThi: "",
        cCauTraLoi: "",
      },
      rules: {

      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogImageUrl: null,
      dialogVisible: false,
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
    },
    handleOpenView(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = Object.assign({}, val)
    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa lượt thi này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(LawExams.deleteLawExams, val.nMaLuotThi).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa lượt thi thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa lượt thi thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cNguoiThi: { value: this.search.cNguoiThi },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(LawExams.findPageLawExams, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm lượt thi thất bại", type: "error" });
      })
    },
    /* handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu lượt thi này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(LawExams.saveLawExams, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật lượt thi thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật lượt thi không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật lượt thi không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(LawExams.saveLawExams, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm lượt thi mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm lượt thi mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm lượt thi mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    }, */
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val.url
      this.dialogVisible = true
    },
    handleGetAnswer(list, val) {

      const filtered = list.filter(item => {
        return item.nMaDapAnPhapLuat == val
      })
      /* console.log(list) */
      if (filtered.length > 0) {
        return filtered[0].cDapAn
      } else {
        return ""
      }
    },
    handleProcessTime(val) {
      if (val) {
        const hours = Math.floor(val/1000 / 3600)
        const minutes = Math.floor((val/1000 % 3600) / 60)
        const seconds = val/1000 % 60
        return `${hours > 0 ? hours + " giờ ":""} ${minutes > 0 ? minutes + " phút ":""}  ${seconds > 0 ? seconds + " giây ":""} `
      } else {
        return ""
      }
    },
    handleCheckPerms(val){
      return this.perms.includes(val)
    }
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss"></style>